import type { CoordinatesByLocation } from "./event.type";

export const genreSelectorTitle = {
    event: "イベント",
    live: "ライブ",
    other: "その他",
} as const;

export const topPageSegmentOptions = [
    { label: "すべて", value: "all" },
    { label: "今日", value: "todays" },
    { label: "フォロー中", value: "following" },
] as const;

export const viewModeText = {
    minimal: "小さく表示",
    full: "大きく表示",
} as const;

export const EventDurationCombBoxOptions = [
    { value: 15, label: "15分" },
    { value: 30, label: "30分" },
    { value: 45, label: "45分" },
    { value: 60, label: "1時間" },
    { value: 75, label: "1時間15分" },
    { value: 90, label: "1時間30分" },
    { value: 105, label: "1時間45分" },
    { value: 120, label: "2時間" },
];

export const SelectPlaceOptionsForKobe = [
    {
        value: "東遊園地西［東遊園地西］",
        label: "東遊園地西［東遊園地西］",
    },
    {
        value: "中央区役所・中央区文化センター前［中央区役所］",
        label: "中央区役所・中央区文化センター前［中央区役所］",
    },
    {
        value: "NTT西日本新神戸ビル西［NTT］",
        label: "NTT西日本新神戸ビル西［NTT］",
    },
    { value: "みなと公園［みなと公園］", label: "みなと公園［みなと公園］" },
    {
        value: "メリケンパーク入口［メリケン入口］",
        label: "メリケンパーク入口［メリケン入口］",
    },
    {
        value: "メリケンパークフィッシュダンス音楽練習場南［フィッシュ］",
        label: "メリケンパークフィッシュダンス音楽練習場南［フィッシュ］",
    },
    {
        value: "メリケンパークBE KOBEモニュメント前 [BE KOBE]",
        label: "メリケンパークBE KOBEモニュメント前 [BE KOBE]",
    },
    // 追加
    {
        value: "サンキタ通り(スターバックス前)",
        label: "サンキタ通り(スターバックス前)",
    },
    {
        value: "神戸阪急グランパティオ（本館２階山側入口前）",
        label: "神戸阪急グランパティオ（本館２階山側入口前）",
    },
    {
        value: "メリケンパーク(BE KOBEモニュメント西側エリア)",
        label: "メリケンパーク(BE KOBEモニュメント西側エリア)",
    },
    { value: "三宮プラッツ", label: "三宮プラッツ" },
    {
        value: "プレンティ広場（西神中央駅前）",
        label: "プレンティ広場（西神中央駅前）",
    },
    { value: "妙法寺駅前広場", label: "妙法寺駅前広場" },
    {
        value: "ユニバードーム(学園都市駅前)",
        label: "ユニバードーム(学園都市駅前)",
    },
    { value: "光の広場(西神南駅前)", label: "光の広場(西神南駅前)" },
    // 新規追加会場
    { value: "スペースシアター", label: "スペースシアター" },
    {
        value: "道の駅 神戸フルーツ・フラワーパーク大沢 音楽堂周辺",
        label: "道の駅 神戸フルーツ・フラワーパーク大沢 音楽堂周辺",
    },
    {
        value: "地下鉄海岸線 御崎公園駅 東改札口付近",
        label: "地下鉄海岸線 御崎公園駅 東改札口付近",
    },
    {
        value: "須磨海浜公園　BE KOBEひろば",
        label: "須磨海浜公園　BE KOBEひろば",
    },
    {
        value: "須磨海浜公園　海のひろば",
        label: "須磨海浜公園　海のひろば",
    },
    {
        value: "メトロこうべ中央広場「metro+」",
        label: "メトロこうべ中央広場「metro+」",
    },
    { value: "新長田駅前広場", label: "新長田駅前広場" },
    {
        value: "地下鉄海岸線 ハーバーランド駅 改札口付近",
        label: "地下鉄海岸線 ハーバーランド駅 改札口付近",
    },
    {
        value: "メリケンパーク　円形広場",
        label: "メリケンパーク　円形広場",
    },
];

export const coordinatesByLocation: CoordinatesByLocation = {
    "東遊園地西［東遊園地西］": {
        lat: "34.687972",
        lng: "135.195694",
    },
    "中央区役所・中央区文化センター前［中央区役所］": {
        lat: "34.689833",
        lng: "135.195083",
    },
    "NTT西日本新神戸ビル西［NTT］": {
        lat: "34.687194",
        lng: "135.189861",
    },
    "みなと公園［みなと公園］": {
        lat: "34.685667",
        lng: "135.190167",
    },
    "メリケンパーク入口［メリケン入口］": {
        lat: "34.685056",
        lng: "135.189889",
    },
    "メリケンパークフィッシュダンス音楽練習場南［フィッシュ］": {
        lat: "34.683889",
        lng: "135.189750",
    },
    "メリケンパークBE KOBEモニュメント前 [BE KOBE]": {
        lat: "34.681361",
        lng: "135.189111",
    },
    // 追加
    "サンキタ通り(スターバックス前)": {
        lat: "34.6936632",
        lng: "135.1931797",
    },
    "神戸阪急グランパティオ（本館２階山側入口前）": {
        lat: "34.6937704",
        lng: "135.1934516",
    },
    "メリケンパーク(BE KOBEモニュメント西側エリア)": {
        lat: "34.6815284",
        lng: "135.1888763",
    },
    妙法寺駅前広場: {
        lat: "34.6745989",
        lng: "135.1103152",
    },
    三宮プラッツ: {
        lat: "34.6906683",
        lng: "135.1935419",
    },
    "ユニバードーム(学園都市駅前)": {
        lat: "34.6820987",
        lng: "135.0567471",
    },
    "光の広場(西神南駅前)": {
        lat: "34.7005417",
        lng: "135.0320812",
    },
    "プレンティ広場（西神中央駅前）": {
        lat: "34.7190157",
        lng: "135.0185213",
    },
    // 新規追加会場の座標
    "スペースシアター": {
        lat: "34.679091",
        lng: "135.1802686",
    },
    "道の駅 神戸フルーツ・フラワーパーク大沢 音楽堂周辺": {
        lat: "34.848978",
        lng: "135.190821",
    },
    "地下鉄海岸線 御崎公園駅 東改札口付近": {
        lat: "34.6548889",
        lng: "135.1665278",
    },
    "須磨海浜公園　BE KOBEひろば": {
        lat: "34.643315",
        lng: "135.1262816",
    },
    "須磨海浜公園　海のひろば": {
        lat: "34.6432502",
        lng: "135.125198",
    },
    "メトロこうべ中央広場「metro+」": {
        lat: "34.6782145",
        lng: "135.1726421",
    },
    "新長田駅前広場": {
        lat: "34.657116",
        lng: "135.145070",
    },
    "地下鉄海岸線 ハーバーランド駅 改札口付近": {
        lat: "34.678787",
        lng: "135.178549",
    },
    "メリケンパーク　円形広場": {
        lat: "34.682714",
        lng: "135.186002",
    },
};
